'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { useCallback, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { useActiveAutcompleteCommand, useActiveAutocompleteTrigger, useAutocompleteErrorState } from '../data/autocompleteAtoms';
import { CopilotAutocompleteHeading } from '../constants/hscontentgeneration';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AutocompleteOptionWrapper = styled.div.withConfig({
  displayName: "AutocompleteOptions__AutocompleteOptionWrapper",
  componentId: "sc-1hlre30-0"
})(["background-color:", ";&:hover{background-color:", " !important;}"], ({
  $isActive,
  theme
}) => $isActive ? theme.color['fill-field-hover'] : '', ({
  theme
}) => theme.color['fill-field-hover']);
const mapTriggerToHeading = {
  '/': CopilotAutocompleteHeading,
  '#': null
};
const AutocompleteErrorMessage = () => /*#__PURE__*/_jsx(ErrorMessage, {
  margin: "0",
  illustrationProps: {
    height: '100px',
    width: '100px'
  },
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "TinymcePlugins.hsautocomplete.errorTitle"
  }),
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "TinymcePlugins.hsautocomplete.errorDescription"
  })
});
export default function AutoCompleteOptions({
  commands
}) {
  const activeAutocompleteCommandIndex = useActiveAutcompleteCommand();
  const activeAutocompleteTrigger = useActiveAutocompleteTrigger();
  const errorState = useAutocompleteErrorState();
  const Heading = mapTriggerToHeading[activeAutocompleteTrigger];
  const optionRefs = useRef([]);
  const blockEvent = useCallback(evt => {
    // Prevent default to avoid blurring the editor in safari
    // onRemove handler runs if this isn't set
    evt.preventDefault();
  }, []);
  useEffect(() => {
    if (activeAutocompleteCommandIndex >= 0 && optionRefs.current[activeAutocompleteCommandIndex]) {
      optionRefs.current[activeAutocompleteCommandIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    }
  }, [activeAutocompleteCommandIndex]);
  if (!commands) {
    return null;
  }
  return /*#__PURE__*/_jsxs(View, {
    alignItems: "flex-start",
    minInlineSize: "130px",
    maxInlineSize: "300px",
    maxBlockSize: "225px",
    overflowY: "auto",
    onMouseDown: blockEvent,
    children: [Heading && /*#__PURE__*/_jsx(Heading, {}), commands.map((command, index) => {
      const isActive = index === activeAutocompleteCommandIndex;
      return (
        /*#__PURE__*/
        // @bend-expect trellis-tokenized
        _jsx(AutocompleteOptionWrapper, {
          $isActive: isActive,
          ref: el => optionRefs.current[index] = el,
          onClick: command.onSelect,
          children: /*#__PURE__*/_jsx(Text, {
            paddingBlock: "200",
            paddingInline: "400",
            margin: "0",
            truncate: true,
            cursor: "pointer",
            children: command.label
          })
        }, command.id)
      );
    }), commands.length === 0 && /*#__PURE__*/_jsx(View, {
      paddingBlock: "200",
      paddingInline: "400",
      margin: "0",
      width: "100%",
      children: errorState ? /*#__PURE__*/_jsx(AutocompleteErrorMessage, {}) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "TinymcePlugins.hsautocomplete.noResults"
      })
    })]
  });
}